module.exports = __webpack_public_path__ + "img/big.53f1eab0.jpg";